import { Component, ElementRef, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { CartsService } from 'projects/cart-tv/src/app/data/cart.sevice';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MiscSnackBarService } from 'projects/core/src/lib/misc/view/snackbar/misc-snackbar.service';
import { Cabinet } from 'projects/app-misc/src/app/modules/cabinets/data/cabinet';
import { ShortProject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-project';

@Component({
  selector: 'app-cart-project-edit-dialog',
  templateUrl: './cart-project-edit-dialog.component.html',
  styleUrls: ['./cart-project-edit-dialog.component.scss']
})
export class CartProjectEditDialogComponent implements OnInit, OnDestroy {
  projs = [];
  selectedObj: any;

  searchString: string;
  projId: number;

  loadingSpinner = false;
  emptyLoadingSpinner = false;
  deleteCartLoadingSpinner = false;

  optionLabel: string;
  objNum: string;

  cartNumber: number

  constructor(
    private cartsService: CartsService,
    protected dialogRef: MatDialogRef<CartProjectEditDialogComponent>,
    protected dialog: MatDialog,
    private miscSnackBarService: MiscSnackBarService,
    protected el: ElementRef,
    @Inject(MAT_DIALOG_DATA) public data: {
      projs: ShortProject[],
      cartId: number,
      selectedId: number
    }
  ) {
    this.projId = data.selectedId;
    this.projs = data.projs

    this.cartNumber = data.cartId

    this.optionLabel = 'name'
    this.objNum = 'number'

    if(this.projs) {
      this.projs.forEach(proj => {
        proj.showName = `${proj.number} - ${proj.name}`
      })
    }
  }

  ngOnInit(): void {
    if(this.data.selectedId) {
      const fCab = this.projs.find(cab => cab.id === this.data.selectedId);
      if(fCab) this.selectedObj = fCab;

      const highlighted = (this.el.nativeElement as HTMLElement).getElementsByClassName('p-highlight');
      if(highlighted) {
        timer(1).subscribe(emit => {
          if(highlighted[0]) {
            highlighted[0].scrollIntoView({block: 'center', behavior: 'auto'})
          }
        })
      }
    }
  }

  request() {
    this.cartsService.changeProject(this.data.cartId, this.selectedObj).subscribe(res => {
      this.dialogRef.close(res);
    }, error => {
      this.miscSnackBarService.openErrorSnackBar(error.message)
      this.loadingSpinner = false;
      this.emptyLoadingSpinner = false;
    })
  }

  save() {
    this.loadingSpinner = true;
    this.request()
  }

  empty() {
    this.emptyLoadingSpinner = true;
    this.selectedObj = null

    this.cartsService.emptyCart(this.data.cartId).subscribe(res => {
      this.dialogRef.close(res);
    }, error => {
      this.miscSnackBarService.openErrorSnackBar(error.message)
      this.loadingSpinner = false;
      this.emptyLoadingSpinner = false;
    })
  }

  deleteCart() {
    this.deleteCartLoadingSpinner = true;

    this.cartsService.deleteCart(this.data.cartId).subscribe(res => {
      this.dialogRef.close('DELETE');
    }, error => {
      this.miscSnackBarService.openErrorSnackBar(error.message)
      this.loadingSpinner = false;
      this.deleteCartLoadingSpinner = false;
    })
  }


  closeDialog() {
    this.dialogRef.close('close-button');
  }

  ngOnDestroy() {

  }

}
